import { Component, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  ScrollToConfigOptions,
  ScrollToService,
} from '@nicky-lenaers/ngx-scroll-to';

import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-minerva-page',
  templateUrl: './minerva-page.component.html',
  styleUrls: ['./minerva-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MinervaPageComponent {
  constructor(
    config: NgbCarouselConfig,
    private title: Title,
    private meta: Meta,
    private scrollToService: ScrollToService
  ) {
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;

    this.meta.addTag({
      name: 'description',
      content:
        'Minerva is a platform that uses AI to improve resident happiness, operational efficiency, sales, and marketing for residential living communities.',
    });
    this.title.setTitle('TSOLife | Minerva–AI for Improved Senior Living');
  }

  triggerScrollTo(target: string) {
    const config: ScrollToConfigOptions = {
      target,
    };
    this.scrollToService.scrollTo(config);
  }
}
